import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { setDeleteLoading } from "../../menu/menuSlice";
import {
  errorAlertHandle,
  successAlertHandle,
} from "../../../../utils/utilFunctions";

export const getUsers = createAsyncThunk(
  "user/getUsers",
  async ({ start, limit, filter }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify(filter);
    const res = await axios.post(
      `/api/user/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return { data: res.data, ...filter };
  }
);

export const addUser = createAsyncThunk(
  "user/addUser",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify(data);
      const res = await axios.post("api/user", body, config);
      successAlertHandle("User added successfully!", dispatch);
      return { type: data.isMobileUser === "yes" ? "mobile" : "web" };
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const updateUser = createAsyncThunk(
  "user/updateUser",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify(data);
      const res = await axios.put("api/user", body, config);
      successAlertHandle("User updated successfully!", dispatch);
      return { data: res.data, isMobileUser: data.isMobileUser };
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const deleteUser = createAsyncThunk(
  "user/deleteUser",
  async (id, { dispatch, rejectWithValue }) => {
    dispatch(setDeleteLoading(true));
    try {
      const res = await axios.delete(`/api/user?id=${id}`);
      successAlertHandle("User deleted successfully!", dispatch);
      dispatch(setDeleteLoading(false));
      return res.data;
    } catch (err) {
      dispatch(setDeleteLoading(false));
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const getRolesNoLimit = async () => {
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({});
    const res = await axios.post(`/api/rbac/filter`, body, config);
    return res.data;
  } catch (error) {
    console.log(error.message);
  }
};

export const getDocImage = async (id, name) => {
  try {
    const res = await axios.get(
      `/api/image?profile=user&id=${id}&name=${name}`
    );
    return res.data;
  } catch (err) {
    throw new Error(err);
  }
};

export const getWarehousesNoLimit = async () => {
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({});
    const res = await axios.post(`/api/loc/warehouse/filter`, body, config);
    return res.data;
  } catch (error) {
    console.log(error.message);
  }
};

export const getAllDocuments = async () => {
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({});
    const res = await axios.post(`/api/document/filter`, body, config);
    return res.data;
  } catch (error) {
    console.log(error.message);
  }
};

export const addDocument = async ({ type, name }) => {
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({ type, name });
    const res = await axios.post(`/api/document`, body, config);
    return res.data;
  } catch (error) {
    console.log(error.message);
  }
};

export const vendorData = async () => {
  try {
    const res = await axios.get(`/api/hooks?name=vendor`);
    return res.data;
  } catch (error) {
    console.log(error.message);
  }
};